import { useState } from 'react';
import { useGetOperationDetail } from '@/common/integrations/menhir/employee/operations/operations.hooks';
import { IOperation } from '@/common/integrations/menhir/employee/operations/operations.types';
import {
  isChildcareOperation,
  isReimbursementExpenseOperation,
  isVoucherExpenseOperation,
} from '@/common/utils/operations';
import { ChildcareDetailDrawer } from '@/web/components/TransactionList/components/OperationDetail/components/ChildcareDetailDrawer/ChildcareDetailDrawer';
import { FailedDetailDrawer } from '@/web/components/TransactionList/components/OperationDetail/components/FailedDetailDrawer/FailedDetailDrawer';
import { MealDetailDrawer } from '@/web/components/TransactionList/components/OperationDetail/components/MealDetailDrawer/MealDetailDrawer';
import { OperationsLerningCenter } from '@/web/components/TransactionList/components/OperationDetail/components/OperationsLearningCenter/OperationsLerningCenter';
import { ReimbursementDetailDrawer } from '@/web/components/TransactionList/components/OperationDetail/components/ReimbursementDetailDrawer/ReimbursementDetailDrawer';
import { useLocalSearchParams } from 'expo-router';

export const OperationDetail = () => {
  const queryParams = useLocalSearchParams<{ operationId: string }>();

  const [operationSelected, setOperationSelected] = useState<IOperation>();

  const { operation } = useGetOperationDetail(queryParams?.operationId ?? '', {
    enabled: !!queryParams.operationId,
  });

  const handleLearningCentre = () => {
    setOperationSelected(operation);
  };

  const closeLearningCentre = () => {
    setOperationSelected(undefined);
  };

  if (!queryParams.operationId || !operation)
    return (
      <>
        {operationSelected && (
          <OperationsLerningCenter
            operation={operationSelected}
            toggleLearningCentre={closeLearningCentre}
          />
        )}
      </>
    );
  let detailComponent;
  if (isReimbursementExpenseOperation(operation)) {
    detailComponent = <ReimbursementDetailDrawer operation={operation} />;
  } else if (
    isVoucherExpenseOperation(operation) &&
    operation.status !== 'rejected'
  ) {
    detailComponent = <MealDetailDrawer operation={operation} />;
  } else if (operation.status === 'rejected') {
    detailComponent = (
      <FailedDetailDrawer
        operation={operation}
        toggleLearningCentre={handleLearningCentre}
      />
    );
  } else if (isChildcareOperation(operation)) {
    detailComponent = <ChildcareDetailDrawer operation={operation} />;
  }

  return (
    <>
      {detailComponent}
      {operationSelected && (
        <OperationsLerningCenter
          operation={operationSelected}
          toggleLearningCentre={closeLearningCentre}
        />
      )}
    </>
  );
};
